import { getCrmTopics } from "../actions/crm_topics";

export const fetchGetCrmTopics = (dispatch: any) => () => dispatch(getCrmTopics());
